
import { Vue, Component, Prop } from 'vue-property-decorator';
import Editor from '@tinymce/tinymce-vue';

@Component({
  components: {
    Editor,
  },
})
export default class SyEditor extends Vue {
  @Prop({ default: 500 }) height!: number;
  @Prop({ default: '请输入' }) placeholder!: string;
  @Prop({ default: '' }) editorName!: string;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: true }) autoSave!: boolean;
  editorInitialized = false;
  content = '';
  init = {
    language: 'zh_CN',
    plugins: 'fullscreen wordcount preview paste autosave',
    toolbar: 'undo redo | fullscreen preview',
    height: this.height,
    branding: false,
    menubar: false,
    placeholder: this.placeholder,
    // statusbar: false,
    // extconfig
    paste_as_text: true,
    autosave_prefix: `sy-rich-editor-${this.editorName}`,
    autosave_restore_when_empty: false,
    autosave_interval: '10s',
    auto_focus: false,
    autosave_ask_before_unload: this.autoSave,
  };
  mounted() {
    this.clear();
    this.editorInitialized = true;
    const localDraft = localStorage.getItem(
      `${this.init.autosave_prefix}draft`,
    );
    const localDraftTime = localStorage.getItem(
      `${this.init.autosave_prefix}time`,
    );
    const currentTime = new Date().getTime();
    if (localDraft && localDraftTime) {
      // 计算时间差，默认有效期20分钟
      const duration = 20 * 60 * 1000;
      if (currentTime - Number(localDraftTime) > duration) {
        console.log('草稿超期不恢复');
      } else {
        this.content = localDraft;
      }
    }
  }
  // 修复在keep alive后编辑器冻结bug
  activated() {
    this.editorInitialized = true;
  }
  deactivated() {
    this.editorInitialized = false;
  }
  // 清除data以及localStorage
  clear() {
    this.content = '';
    localStorage.removeItem(`${this.init.autosave_prefix}draft`);
    localStorage.removeItem(`${this.init.autosave_prefix}time`);
  }
  getPlainText() {
    return window.tinymce.activeEditor.getContent({ format: 'text' });
  }
}
